module.exports = __webpack_public_path__ + "img/ring_g_c_1_0@2x.ddb32272.png";